var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingcard4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.46875,
    y: 0.70459,
    width: 49.7786,
    height: 49.7767,
    rx: 24.8883,
    fill: "url(#paint0_radial_136_2062)",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.46875,
    y: 0.70459,
    width: 49.7786,
    height: 49.7767,
    rx: 24.8883,
    fill: "url(#paint1_radial_136_2062)",
    fillOpacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.913194,
    y: 1.14903,
    width: 48.8898,
    height: 48.8878,
    rx: 24.4439,
    stroke: "white",
    strokeOpacity: 0.24,
    strokeWidth: 0.888889
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_136_2062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.074 21.4648C37.5628 21.4648 39.5805 23.313 39.5808 25.5918C39.5808 27.8709 37.563 29.7188 35.074 29.7188C34.7379 29.7187 34.4105 29.684 34.0955 29.6201C30.5215 29.2092 26.2397 26.2797 25.45 25.7207C25.9777 26.4628 28.6148 30.2981 29.2625 33.7207C29.4365 34.2174 29.5329 34.7563 29.533 35.3193C29.5328 37.8014 27.6807 39.8139 25.3962 39.8145C23.1115 39.8143 21.2587 37.8016 21.2585 35.3193C21.2586 34.9844 21.2932 34.6578 21.3572 34.3438C21.77 30.7742 24.7139 26.4958 25.2683 25.7168C24.4867 26.2703 20.1994 29.2086 16.6208 29.6201C16.306 29.6839 15.9782 29.7187 15.6423 29.7188C13.1536 29.7185 11.1356 27.8707 11.1355 25.5918C11.1358 23.3131 13.1537 21.4651 15.6423 21.4648C16.2055 21.4649 16.745 21.5616 17.2419 21.7344C20.8418 22.4105 24.8989 25.272 25.3533 25.5986C25.3556 25.5955 25.3575 25.5937 25.3582 25.5928C25.3586 25.5934 25.3598 25.5955 25.3621 25.5986C25.8135 25.274 29.8722 22.411 33.4734 21.7344C33.9708 21.5612 34.5102 21.4649 35.074 21.4648ZM25.321 11.3711C27.606 11.3711 29.4587 13.3837 29.4587 15.8662C29.4587 16.2012 29.4241 16.5278 29.3601 16.8418C28.905 20.7774 25.3722 25.5737 25.3582 25.5928C25.3266 25.5499 22.1678 21.2499 21.4529 17.459C21.2801 16.964 21.1844 16.427 21.1843 15.8662C21.1844 13.3841 23.0366 11.3717 25.321 11.3711Z",
    fill: "url(#paint2_radial_136_2062)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_136_2062",
    x: 5.80216,
    y: 9.59332,
    width: 39.112,
    height: 39.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.55556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_136_2062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_136_2062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_136_2062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3581 15.8709) rotate(-90) scale(25.2772 33.3039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_136_2062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3581 16.2598) rotate(-90) scale(25.6661 33.8163)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_136_2062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3581 25.5928) rotate(90) scale(47.6973 47.7006)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingcard4);
export default __webpack_public_path__ + "static/media/pricingcard4.1477e31425fe301c27ec988575177279.svg";
export { ForwardRef as ReactComponent };